import { create } from "zustand";


export const useStoreLayout = create((set) => ({
	sidebar: false,

	openSidebar: () => set(() => ({ sidebar: true })),
	closeSidebar: () => set(() => ({ sidebar: false }))
}));